export const fromEntries = <T>(data: [string, T][]): Record<string, T> => data
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
